import axios from 'axios';

export default class IELAPIService {
    constructor({ baseURL, accessToken, refreshToken = '' }) {
        this.baseURL = baseURL;
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
    }

    //Handle making sure our url ends with a slash
    set baseURL(url) {
        let slashRegex = /\/$/g;
        if (!url.match(slashRegex)) {
            url += '/'; //add a slash if we dont have one at the end
        }
        this._baseURL = url;
    }

    get baseURL() {
        return this._baseURL;
    }

    // - Login Should NOT be over-ridden 
    //     Use beforeLogin, afterLoginSuccess and afterLoginError for pre/post authentication behavior
    login(username, password, clientID, clientSecret) {
        this.beforeLogin();
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: `${this.baseURL}oauth/token`,
                data: {
                    username,
                    password,
                    client_id: clientID,
                    client_secret: clientSecret,
                    grant_type: 'password'
                }
            }).then((result) => {
                this.accessToken = result.data.access_token;
                this.refreshToken = result.data.refresh_token;
                this.afterLoginSuccess(result);
                resolve(result);
            }).catch((reject)  => {
                this.afterLoginError(reject);
            })
        });
    }

    beforeLogin() {
    }

    afterLoginError() {
    }

    afterLoginSuccess(result) {
    }

    _withToken() {
        return axios.create({
            headers: {
                'Authorization': `Bearer ${this.accessToken}`,
                'Content-Type': 'application/json'
            },
            baseURL: this.baseURL
        });
    }

    _getFileWithToken() {
        return axios.create({
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${this.accessToken}`,
                'Content-Type': 'application/json'
            },
            baseURL: this.baseURL
        });
    }
}